var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogouticon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Logout_icon",
    "data-name": "Logout icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 16.007,
    viewBox: "0 0 15 16.007",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_36447",
    "data-name": "Path 36447",
    d: "M278,218.864v14.231h0v.005h0v.011a.9.9,0,0,1-.9.894A.366.366,0,0,1,277,234h-2a1.2,1.2,0,0,1-1.2-.869A1.48,1.48,0,0,1,275,232h1V220h-1a1.4,1.4,0,0,1-1.2-1.1h0a1.232,1.232,0,0,1,1.2-.9h2A.972.972,0,0,1,278,218.864Zm-4.2,7.151-4.118,4.361a.843.843,0,0,1-1.234,0,.945.945,0,0,1,0-1.293L270,227h-6a1,1,0,0,1,0-2h6l-1.554-2.054a.945.945,0,0,1,0-1.293.845.845,0,0,1,1.234,0Z",
    transform: "translate(-263 -217.999)",
    fill: "red",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogouticon);
export default __webpack_public_path__ + "static/media/Logout icon.859e3a582b2edd41fbd92e746c96f6c3.svg";
export { ForwardRef as ReactComponent };